/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
export default {
  name: "StudyCountry",
  components: {
    VPagination,
  },
  data() {
    return {
      searchField: {
        country: "",
        status: "",
      },
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/country/`,
      baseapi: process.env.VUE_APP_Service_URL,
      currentPage: 1,
      totalPage: 1,
      pageindex: 1,
      pagesize: 15,
      SortProperty: "createdAt",
      SortOrder: 1,
      SortOrderInt: 0,
       isAscending: true,
      countryList: [],
      totalCount: 0,
      showTableLoading: false,
      idToken: "",
      showFilter: false,
      selectedcolumnobj: {},
      roleprivileges: "",
      CountryStatus: [],
      dropdownOpen: false,
      selectedcolumnobj: {},
    }
  },
  watch: {
    returnList: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.idToken = store.getters.getIdToken;
      this.fetchStudyCountry();
    });
    await this.fetchStudyCountry();
    await this.setroleprivileges();
    await this.getAllCountryStatus();
  },

  methods: {
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    initializeColumns() {
      if (this.countryList.length > 0) {
        const allowedKeys = [
          "Country Name",
          "Country Code",
          "Notes",
          "Active",
          "Language",
          "Language Code",
        ];

        const fieldLabels = {
          countryName: "Country Name",
          countryCode: "Country Code",
          notes: "Notes",
          active: "Active",
          language: "Language",
          languageCode: "Language Code",
        };

        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        this.getColumns = readableData;

        this.selectedColumns = [...this.getColumns];

        this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
          obj[key] = true;
          return obj;
        }, {});
      }
    },

    async fetchStudyCountry() {
      try {
        this.showTableLoading = true;
        const currentstudy = store.getters.getStudyIs;
        this.idToken = store.getters.getIdToken;
        const response = await axios.get(`${this.baseUrl}getstudycountries`, {
          params: {
            countryName: this.searchField.country,
            countryCode: "",
            StudyId: currentstudy,
            status: this.searchField.status,
            sortproperty: this.SortProperty,
            sortorder: this.SortOrderInt,
            pageindex: this.currentPage,
            pagesize: this.pagesize
          },
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json"
          }
        });

        this.countryList = response.data.entities || [];
        this.totalCount = response.data.totalCount || this.countryList.length;

        this.totalPage = Math.ceil(this.totalCount / this.pagesize);
      } catch (error) {
        console.error(error);
      } finally {
        this.showTableLoading = false;
      }
    },
    CreateCountry(id) {

      this.$router.push(`/ManageCountry/${id}`);
    },
    EditCountry(id) {
      this.$router.push(`/ManageCountry/${id}`);
    },
    async DeleteCountry(id) {
      if (confirm("Are you sure you want to delete this country?")) {
        try {
          const response = await axios.delete(`${this.baseUrl}deletecountry?id=${id}`, {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json"
            }
          });
          alert("Country deleted successfully.");
          this.fetchStudyCountry();
        } catch (error) {
          console.error(error);
        }
      }
    },
    loadPage(page) {
      this.currentPage = page;
      // this.pageindex = page;
      this.fetchStudyCountry();
    },
    async getAllCountryStatus() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/statusmaster/getall?StatusType=Country`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.CountryStatus = response.data

        })
        .catch((err) => {
          console.log(err);
        });
    },
    async search() {

      this.pageindex = 1;
      this.currentPage = 1;
      this.fetchStudyCountry();
    },
    formatDateDDMMYYYY(date) {
      if (!date) return "";
      const d = new Date(date);

      // Use UTC to avoid timezone shifts
      const day = String(d.getUTCDate()).padStart(2, "0");
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const year = d.getUTCFullYear();

      return `${day}-${month}-${year}`;

    },
    SortSelected(sortProp) {
  if (this.SortProperty === sortProp) {
    this.isAscending = !this.isAscending;
  } else {
    this.SortProperty = sortProp;
    this.isAscending = true;
  }
  this.SortOrderInt = this.isAscending ? 0 : 1;
  this.pageindex = 1;
  this.currentPage = 1;
  this.fetchStudyCountry();
}

  }
};
